import { formatAsUSD } from '@la/utilities';
import { getAddOnPriceRange } from '../../Tournaments/TournamentDetailsPage/utils/feeCalculationUtils';
import styles from './AddOnCard.module.scss';

export default function AddOnPriceRange({
  maxFee,
  minFee,
  salesTaxRequired,
  selectedProductPrice,
}: Readonly<{
  maxFee: number;
  minFee: number;
  salesTaxRequired: boolean;
  selectedProductPrice?: number;
}>) {
  const addOnPriceRange = getAddOnPriceRange({
    maxFee,
    minFee,
  });

  /*
  Checking for falsy values here because the selectedProductPrice
  is possibly 0 but null or undefined are not acceptable
   */
  const priceInformation =
    selectedProductPrice != null
      ? formatAsUSD(selectedProductPrice)
      : addOnPriceRange;

  if (!addOnPriceRange && !selectedProductPrice) {
    return null;
  }

  return (
    <span className={styles.priceRange}>
      {priceInformation}
      {salesTaxRequired ? (
        <span className={styles.plusTax}> +&nbsp;tax</span>
      ) : null}
    </span>
  );
}
